import { Skeleton } from '@/common/ui/skeleton'
import { TableCell, TableRow } from '@/common/ui/table'

export function DataTableSkeleton({ columnCount = 1, rowCount = 10 }) {
	return (
		<>
			{Array.from({ length: rowCount }).map((_, rowIndex) => (
				<TableRow
					key={rowIndex}
					className={`h-16 hover:bg-transparent ${
						rowIndex % 2 === 0 ? 'bg-muted/50' : ''
					}`}
				>
					{Array.from({ length: columnCount }).map((_, colIndex) => (
						<TableCell key={colIndex} className="p-4">
							<div className="flex items-center space-x-2">
								<Skeleton className="h-4 flex-1" />
							</div>
						</TableCell>
					))}
				</TableRow>
			))}
		</>
	)
}
